import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { ActionsPropertiesType } from "@website/ui/datepicker/components/actions/actions.types";
export const useActions = properties => {
  const $ = _c(9);
  const {
    showToday,
    changeCalendarLocale
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon name="sync" variant="outlined" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== showToday) {
    t1 = {
      onClick: showToday,
      StartIcon: t0,
      color: "secondary" as const,
      size: "small" as const,
      variant: "text" as const
    };
    $[1] = showToday;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="swap_horiz" variant="outlined" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== changeCalendarLocale) {
    t3 = {
      onClick: changeCalendarLocale,
      StartIcon: t2,
      color: "secondary" as const,
      size: "small" as const,
      variant: "text" as const
    };
    $[4] = changeCalendarLocale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = {
      showTodayButtonProperties: t1,
      changeCalendarLocaleButtonProperties: t3
    };
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};